export default __webpack_public_path__ + "static/cv-8bc509e1eaead5efe8f794190ac008bb.png";